import styled             from 'styled-components';

import { MailVector     } from 'src/components/vector/mail';
import { CalendarVector } from 'src/components/vector/calendar';
import { EditVector     } from 'src/components/vector/edit';

import { cssFlexRow,
         themeColors, 
         themeTypos,
         Typo,
         typoAsCSS      } from 'src/providers/theme/shared';
import { NoteEditVector } from 'src/components/vector/note-edit';



type DateLabelLookAndFeel = {
  height: number;
  typo: Typo;
  color: string;
  icon: React.ReactNode;
  iconColor: string;
  iconSize?: number;
  labelGap: number;
}

const datelabel_h24bluecalendar: DateLabelLookAndFeel = {
  height: 24,
  typo: themeTypos.GRTSKREG_W400_S10_LH16,
  color: themeColors.AccentBlue1,
  icon: <CalendarVector />,
  iconColor: themeColors.AccentBlue1,
  labelGap: 8,
}

const datelabel_h24blue2calendar: DateLabelLookAndFeel = {
  height: 24,
  typo: themeTypos.GRTSKREG_W400_S15_LH22,
  color: themeColors.AccentBlue2,
  icon: <CalendarVector />,
  iconColor: themeColors.AccentBlue2,
  labelGap: 8,
}

const datelabel_h16blueredmail: DateLabelLookAndFeel = {
  height: 16,
  typo: themeTypos.GRTSKREG_W400_S10_LH16,
  color: themeColors.AccentBlue1,
  icon: <MailVector />,
  iconColor: themeColors.AccentRed1,
  labelGap: 8,
}

const datelabel_h24grayedit: DateLabelLookAndFeel = {
  height: 24,
  typo: themeTypos.GRTSKREG_W400_S10_LH16,
  color: themeColors.SecondaryGray5,
  icon: <EditVector />,
  iconColor: themeColors.SecondaryGray5,
  labelGap: 8,
}

const datelabel_h40black: DateLabelLookAndFeel = {
  height: 40,
  typo: themeTypos.GRTSKREG_W400_S15_LH22,
  color: themeColors.PrimaryBlack,
  icon: <NoteEditVector />,
  iconColor: themeColors.PrimaryBlack,
  labelGap: 12,
  iconSize: 24
}

export type DateLabelVariants = 'h24bluecalendar' | 
                                'h24blue2calendar' | 
                                'h16blueredmail' | 
                                'h24grayedit' |
                                'h40black';

export const datelabel_variants: Map<DateLabelVariants, DateLabelLookAndFeel> = 
  new Map<DateLabelVariants, DateLabelLookAndFeel>([
    ['h24bluecalendar', datelabel_h24bluecalendar],
    ['h24blue2calendar', datelabel_h24blue2calendar],
    ['h16blueredmail', datelabel_h16blueredmail],
    ['h24grayedit', datelabel_h24grayedit],
    ['h40black', datelabel_h40black]
  ]);

export const Container = styled.div<{
  lookAndFeel: DateLabelLookAndFeel
}>`
  ${cssFlexRow};
  align-items: center;

  color: ${(args) => args.lookAndFeel.color};
  height: ${(args) => args.lookAndFeel.height}px;

  width: 100%;
  gap: ${(args) => args.lookAndFeel.labelGap}px;

  & > svg {
    color: ${(args) => args.lookAndFeel.iconColor};
    width: ${(args) => args.lookAndFeel.iconSize ? args.lookAndFeel.iconSize : 'auto'}px;
    height: ${(args) => args.lookAndFeel.iconSize ? args.lookAndFeel.iconSize : 'auto'}px;
  }
`

export const Label = styled.span<{
  lookAndFeel: DateLabelLookAndFeel,
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.typo)}
`

export const HStack = styled.div`
  ${cssFlexRow};
  justify-content: flex-end;
  gap: 10px;

  & > * {
    border-radius: 9999px;  
  }
`
